import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {UrlService} from '@shared/services/url.service';
import {Observable} from 'rxjs';
import {API_ENTITY_INVESTMENT_TRANSACTIONS, API_ENTITY_INVESTMENTS} from '../../../config/urls';
import {EntityInvestmentListDto} from '@dto/holdings/entity-investment-list.dto';
import {EntityInvestmentTransactionListDto} from '@dto/holdings/entity-investment-transaction-list.dto';

@Injectable({
  providedIn: 'root'
})
export class EntityInvestmentService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public getEntityInvestments(entityCode: string): Observable<EntityInvestmentListDto> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_INVESTMENTS, entityCode);
    return this.http.get<EntityInvestmentListDto>(endpointUrl);
  }

  public getEntityInvestmentTransactions(entityCode: string, entityInvestmentId: string, entityInvestmentPortfolioNumber: string): Observable<EntityInvestmentTransactionListDto> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_INVESTMENT_TRANSACTIONS, entityCode, entityInvestmentId, entityInvestmentPortfolioNumber);
    return this.http.get<EntityInvestmentTransactionListDto>(endpointUrl);
  }
}
